module.exports = __webpack_public_path__ + "static/img/footerPhoto3.ab9eed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footerPhoto3.png
// module id = jmv/
// module chunks = 0